import BaseSearchBar from "./BaseSearchBar";

export default BaseSearchBar;
